'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002441 from "./presto.types$-Grouping-Description$$anon$41.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002442 from "./presto.types$-Grouping-Description$$anon$42.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingDescription$() {
  this.c83 = null;
  this.c84 = false;
  this.c81 = null;
  this.c82 = false;
  this.c87 = null;
  this.c88 = false;
  this.c85 = null;
  this.c86 = false;
  this.c89 = null;
  this.c8a = false;
}
export { $c_Lpresto_types$GroupingDescription$ as $c_Lpresto_types$GroupingDescription$ };
$p = $c_Lpresto_types$GroupingDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingDescription$;
/** @constructor */
function $h_Lpresto_types$GroupingDescription$() {
}
export { $h_Lpresto_types$GroupingDescription$ as $h_Lpresto_types$GroupingDescription$ };
$h_Lpresto_types$GroupingDescription$.prototype = $p;
$p.cJ8 = (function() {
  if ((!this.c84)) {
    this.c83 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c84 = true;
  }
  return this.c83;
});
$p.pc = (function() {
  if ((!this.c82)) {
    this.c81 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c82 = true;
  }
  return this.c81;
});
$p.cJM = (function() {
  if ((!this.c88)) {
    this.c87 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c88 = true;
  }
  return this.c87;
});
$p.cJy = (function() {
  if ((!this.c86)) {
    this.c85 = new $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002441.$c_Lpresto_types$GroupingDescription$$anon$41(this);
    this.c86 = true;
  }
  return this.c85;
});
$p.cK4 = (function() {
  if ((!this.c8a)) {
    this.c89 = new $j_presto$002etypes$0024$002dGrouping$002dDescription$0024$0024anon$002442.$c_Lpresto_types$GroupingDescription$$anon$42(this);
    this.c8a = true;
  }
  return this.c89;
});
var $d_Lpresto_types$GroupingDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingDescription$, "presto.types$GroupingDescription$", ({
  a0o: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingDescription$ as $d_Lpresto_types$GroupingDescription$ };
var $n_Lpresto_types$GroupingDescription$;
function $m_Lpresto_types$GroupingDescription$() {
  if ((!$n_Lpresto_types$GroupingDescription$)) {
    $n_Lpresto_types$GroupingDescription$ = new $c_Lpresto_types$GroupingDescription$();
  }
  return $n_Lpresto_types$GroupingDescription$;
}
export { $m_Lpresto_types$GroupingDescription$ as $m_Lpresto_types$GroupingDescription$ };
//# sourceMappingURL=presto.types$-Grouping-Description$.js.map
